import type { PayloadAction } from '@reduxjs/toolkit';
import { all, put, takeLatest } from 'redux-saga/effects';

import RestCLient from '~/modules/requests';

import {
  getTours,
  getToursFailure,
  getToursSuccess,
} from '~/actions';

import { ApiResponse } from '~/types';
import { CONFIG } from '~/config';
import { Tour } from '~/types/tours';
import { TourSearchParams } from '~/store/slices/tour-search';

/**
 * Get Flights
 *
 * @param {Object} action
 *
 */

export function* getToursSaga({ payload }: PayloadAction<TourSearchParams>) {
  try {
    const response: ApiResponse<Tour[]> = yield RestCLient.get(
      `${CONFIG.env.apiBaseUrl}v1/tours/search?${new URLSearchParams(payload as Record<string, any>).toString()}`,
    );

    if (response.status === 200) {
      const toursData = response.data;
      yield put(getToursSuccess(toursData?.length ? toursData : []));
    }
  } catch (error: any) {
    yield put(getToursFailure(error.message));
  }
}


/**
 * Flights Sagas
 */
export default function* root() {
  yield all([
    takeLatest(getTours.type, getToursSaga),
  ]);
}
